import React, { useEffect, useState } from 'react';
import { ResetPasswordForm } from './ResetPasswordForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';
import { useLoader } from 'src/provider/LoaderProvider';
import { useLazyResetPasswordQuery } from 'src/services/authSsoService';

const SuccessContent = ({ onPopupClose }) => {
  return (
    <div className="grid gap-5 pt-[30px] pb-2.5 text-base text-center">
      <div>
        <p className={'font-semibold text-ebony'}>
          Check your email for instructions to reset your password.
        </p>
        <p className={'font-normal text-ebony'}>
          If you don’t see them in your inbox, check your spam folder.
        </p>
      </div>
      <div className="w-[130px] m-auto">
        <Button className="green !mt-0 min-w-[125px]" onClick={onPopupClose}>
          Ok
        </Button>
      </div>
    </div>
  );
};

export const ResetPasswordPopup = ({ disabled = false }) => {
  const [open, setOpen] = useState(false);
  const loader = useLoader();
  const [resetPassword, { isFetching, isSuccess }] = useLazyResetPasswordQuery();

  useEffect(() => {
    if (isFetching) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isFetching]);

  const closePopup = () => {
    setOpen(false);
  };

  const handleSubmit = (email) => {
    resetPassword({ email: email.trim() });
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <button className="transition-all">
          <p className="font-medium text-xs text-[#3F60B3] hover:underline">
            Forgot your password?
          </p>
        </button>
      </DialogTrigger>
      <DialogContent
        closeButtonHidden={true}
        className={'backdrop-blur-[20px] bg-[rgba(255,255,255,0.80)]'}
      >
        {isSuccess ? (
          <SuccessContent onPopupClose={closePopup} />
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className={'text-center text-lg font-bold font-jamjuree text-ebony'}>
                Reset password
              </DialogTitle>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <ResetPasswordForm closePopup={closePopup} submit={handleSubmit} />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
